"use client";
import styles from "./Navbar.module.scss";
import { MenuType } from "../../types/baseTypes";
import { NavigationOptionsType } from "@/types/ModuleOptionsType";
import { Menu } from "./Menu/Menu";
import { LanguageToggle } from "./Language/LanguageToggle";
import { Hamburger } from "./Hamburger/Hamburger";
import { useState, useEffect } from "react";
import { useAppContext } from "../../context/AppContext";
import { FocusTrap } from "@aleksundshantu/aunds-utils-react/accessibility";
import { Post } from "@aleksundshantu/aunds-hofreiter2026-types/client";

interface NavbarProps {
  menu: MenuType;
  navbarOption: NavigationOptionsType;
  pageData?: Post;
  isHome: boolean;
  logos: JSX.Element;
  search: JSX.Element | false;
  socialMedia: JSX.Element | false;
  hideMenu: boolean;
}

export const NavbarClient = ({
  navbarOption,
  menu,
  pageData,
  isHome,
  logos,
  search,
  socialMedia,
  hideMenu = false,
}: NavbarProps) => {
  const { show_box_shadow, show_search, show_language, show_background } =
    navbarOption.header_menu;
  const [hasBackground, setHasBackground] = useState<boolean>(false);
  const { openMenu } = useAppContext();

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      setHasBackground(scrollY > 100);
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      data-has-bg={isHome && !show_background ? hasBackground : true}
      data-show-shadow={show_box_shadow}
      //! please dont remove scrollbar-width class
      className={`${styles["navbar"]} ${openMenu ? styles["opened"] : ""} navbar scrollbar-width`}
    >
      {logos}
      {!hideMenu && <Hamburger />}
      <FocusTrap disabled={!openMenu}>
        <div
          id="navbar-main"
          data-show-search={show_search}
          data-lenis-prevent
          className={`${styles["navbar-main"]} ${openMenu ? styles["opened"] : ""}`}
        >
          <div className={styles["navbar-main-mobile-scroll"]}>
            {!hideMenu && <Menu menu={menu} pageData={pageData} />}
            {socialMedia}
            {show_language && pageData && (
              <LanguageToggle addWrapper={true} post={pageData} />
            )}
            {!hideMenu && search}
          </div>
        </div>
      </FocusTrap>
    </nav>
  );
};
